// extracted by mini-css-extract-plugin
export var label = "_ez-2";
export var slideContainer = "_ez-0";
export var slider = "_ez-1";